import React from 'react';
import {connect} from 'react-redux';
import {Dashboard as BaseDashboard} from 'components/organisms/used-players-list/components/dashboard';

class Dashboard extends BaseDashboard {
    render() {
        const lineupsQuantity = this.getLineupsQuantity();
        const usedPlayersQuantity = this.getUsedPlayersQuantity();

        return (
            <div className="lineups-info-holder">
                <ul className="lineups-info">
                    <li>
                        <strong>{usedPlayersQuantity}</strong> Players Used
                    </li>
                    <li>
                        <strong>{lineupsQuantity}</strong> Lineups
                    </li>
                </ul>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {usedPlayers, lineupsData, filterLineupsByPlayer} = state;
    return {
        usedPlayers: usedPlayers.players,
        lineups: lineupsData.lineups,
        filterLineupsByPlayer,
    };
}

export default connect(mapStatesToProps)(Dashboard);
